import { ELoadingStatus } from '../../types/loadingStatus';
import { IApplicationState } from '../../types/redux';

export const selectIsLoading = (state: IApplicationState): boolean => {
  return state.loadingStatus.requestStatus === ELoadingStatus.Loading;
};
